import { render } from "./ProjectSummary.vue?vue&type=template&id=d0555a4a&scoped=true"
import script from "./ProjectSummary.vue?vue&type=script&lang=js"
export * from "./ProjectSummary.vue?vue&type=script&lang=js"

import "./ProjectSummary.vue?vue&type=style&index=0&id=d0555a4a&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0555a4a"]])

export default __exports__